import type { PuzzleResult } from './PuzzleGenerator';

// Shape types: 0=circle, 1=square, 2=triangle, 3=diamond, 4=pentagon, 5=hexagon, 6=star, 7=cross
const SHAPE_COUNT = 8;

export function generateShapeMatch(complexity: number, subtlety: number): PuzzleResult {
  const pairCount = Math.min(Math.floor(complexity / 2) + 1, 4);
  const shapePool = Math.min(3 + Math.floor(subtlety * 5), SHAPE_COUNT);

  // Generate pairs: each row is [shapeType, colorIdx]
  const reference: number[][] = [];
  for (let i = 0; i < pairCount * 2; i++) {
    const shape = Math.floor(Math.random() * shapePool);
    const color = Math.floor(Math.random() * 4);
    reference.push([shape, color]);
  }

  const hasError = Math.random() < 0.75;

  let output: number[][];
  if (hasError) {
    output = reference.map(r => [...r]);
    const mutPos = Math.floor(Math.random() * output.length);

    if (subtlety < 0.3) {
      // Easy: change to a completely different shape
      let newShape: number;
      do {
        newShape = Math.floor(Math.random() * shapePool);
      } while (newShape === output[mutPos][0]);
      output[mutPos][0] = newShape;
    } else if (subtlety < 0.7) {
      // Medium: change the color but keep the shape
      output[mutPos][1] = (output[mutPos][1] + 1) % 4;
    } else {
      // Hard: swap two similar shapes
      const swapWith = (mutPos + 1) % output.length;
      [output[mutPos], output[swapWith]] = [output[swapWith], output[mutPos]];
    }
  } else {
    output = reference.map(r => [...r]);
  }

  return {
    reference,
    output,
    hasError,
    referenceLabel: 'Reference Shapes',
    outputLabel: 'Agent Output',
  };
}
